import React, { useEffect, useMemo, useState } from 'react';
import { Divider, Menu, Modal, Spin, Table, InputNumber } from 'antd';
import { connect } from 'react-redux';
import JankFlameGraph from 'components/exception/issue/DataHead/JankFlameGraph';
import JankDiffFlameGraph from 'components/exception/issue/DataHead/JankDiffFlameGraph';
import scss from './SubJankIssueFlameGraphModal.scss';
import { Select } from 'antd/es';
import { ze } from 'utils/zhEn';
import CsTabs from 'components/antd-extension/CsTabs';
import { useCrashsightLocalStorage } from 'utils/useCrashSightLocalStorage';
import { ExceptionTypeInt, ExceptionTypeName } from 'utils/constants/exception-type-int';
import RestHelper from 'utils/RestHelper';
import { FieldName, QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { useLocalStorageStateOfJankIssue } from 'utils/react-hooks/cs-local-storage-hooks';
import { getIssueDetailUrlPrefix } from 'utils/helper';
import { ExceptionCategory } from 'utils/exception-category';
import { Link } from 'react-router-dom';

const SubJankIssueDomItem = ({
  reduxState,
  mergedIssueList,
  onFetchSubJankTopIssues,
  initialMergedIssueId,
  diffModeTab,
  uniqueIdentifier,//每次调用的一个唯一标识
  onChangeFlameGraphData, // 新增的回调prop
}) => {
  // 王者卡顿，虚拟issue ID -> 子issue list
  const mergedIssueIdToSubJankTopIssueData = useMemo(() => {
    const v = reduxState.summary.get('mergedIssueIdToSubJankTopIssueData');
    return v || {};
  }, [reduxState.summary]);

  const mergedIssueIdListOptions = useMemo(() => {
    const mergedIssueIdList = (mergedIssueList || []).map(x => x.issueId);
    return mergedIssueIdList.map(x => ({ label: x, value: x }));
  }, [mergedIssueList]);

  const [loading, setLoading] = useState(false);

  const [selectedMergedIssueId, setSelectedMergedIssueId] = useState('');
  const [issueIdList, setIssueIdList] = useState([]);
  const [selectedIssueId, setSelectedIssueId] = useState('');
  const [issueIdToFlameGraphData, setIssueIdToFlameGraphData] = useState({});

  const [fetchSubIssuesTrigger, setFetchSubIssuesTrigger] = useState(0);

  const selectedFlameGraphData = issueIdToFlameGraphData[selectedIssueId];

  useEffect(() => {
    if (selectedIssueId) {
      onChangeFlameGraphData(selectedFlameGraphData,uniqueIdentifier);
    }
  }, [selectedFlameGraphData]);

  const menuItems = useMemo(() => {
    return issueIdList.map((issueId, i) => ({ label: `(${i+1}) ${issueId}`, key: issueId }));
  }, [issueIdList]);

  const currentApp = reduxState.app.get('current').toJS();
  const { appId, platformId } = currentApp;

  useEffect(() => {
    if (initialMergedIssueId) {
      setSelectedMergedIssueId(initialMergedIssueId);
      setFetchSubIssuesTrigger(fetchSubIssuesTrigger + 1);
    }
  }, [initialMergedIssueId]);

  useEffect(() => {
    fetchSubJankIssuesFlameGraphData(selectedMergedIssueId);
  }, [fetchSubIssuesTrigger]);

  async function fetchSubJankIssuesFlameGraphData(mergedIssueId) {
    setLoading(true);
    const subJankTopData = mergedIssueIdToSubJankTopIssueData[mergedIssueId];
    const topIssueList = subJankTopData?.topIssueList || [];
    const issueIdList = topIssueList.map((issue) => issue.issueId);
    setIssueIdList(issueIdList);
    if (issueIdList.length === 0) {
      setLoading(false);
      return;
    }

    const rsp = await RestHelper.mustPost('/api/issue/queryIssueList', {
      appId,
      platformId,
      rows: 1000,
      issueIds: issueIdList,
    });
    const issueList = rsp.json.ret?.issueList || [];
    const issueIdAndFlameGraphDataEntries = issueList.map((issue) => {
      const { issueId, lastMatchedReport } = issue;
      const jankFlameGraphJson = lastMatchedReport?.crashMap?.jankFlameGraphJson;
      let jankFlameGraphData = null;
      if (jankFlameGraphJson) {
        try {
          jankFlameGraphData = JSON.parse(jankFlameGraphJson);
        } catch (e) {
          message.error(`解析火焰图失败, issueId = ${issueId}`);
        }
      }
      return [issueId, jankFlameGraphData];
    });
    setIssueIdToFlameGraphData(Object.fromEntries(issueIdAndFlameGraphDataEntries));
    setLoading(false);
  }

  const dom = <Spin spinning={loading}><div>
    <div>
      <Select
        style={{ width: '320px' }}
        options={mergedIssueIdListOptions}
        value={selectedMergedIssueId}
        onChange={async (v) => {
          setLoading(true);
          setSelectedMergedIssueId(v);
          await onFetchSubJankTopIssues(v);
          setFetchSubIssuesTrigger(fetchSubIssuesTrigger + 1);
        }}
      />
    </div>
    <div style={{ display: 'flex', gap: '12px' }}>
      <div style={{ width: '320px', height: '40vh', overflowY: 'auto', overflowX: 'hidden' }}>
        <Menu
          inlineIndent={0}
          mode="inline"
          onClick={({ key }) => setSelectedIssueId(key)}
          items={menuItems}
        >
        </Menu>
      </div>
     {diffModeTab !== 'difference' && <div style={{ flexGrow: 1 }}>
        { !!selectedFlameGraphData && <JankFlameGraph
          data={selectedFlameGraphData}
        />}
      </div>}
    </div>
  </div></Spin>;

  return dom;
}

const IssueDetailCompareModeJankIssueDomItem = ({
  reduxState,
  isBaseNotCompare,
  diffModeTab,
  uniqueIdentifier, //每次调用的一个唯一标识
  onChangeFlameGraphData = () => {}, // 新增的回调prop
}) => {
  const currentApp = reduxState.app.get('current').toJS();
  const { appId, platformId } = currentApp;

  const [jankIssueStorage, setJankIssueStorage] = useLocalStorageStateOfJankIssue();
  let issueIdFromStorage = null;
  if (jankIssueStorage && jankIssueStorage.appId === appId) {
    issueIdFromStorage = isBaseNotCompare
      ? jankIssueStorage.baseIssueId
      : jankIssueStorage.compareIssueId;
  }

  const [issueId, setIssueId] = useState(issueIdFromStorage);
  const [flameGraphData, setFlameGraphData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIssueId(issueIdFromStorage);
  }, [issueIdFromStorage]);

  useEffect(() => {
    onChangeFlameGraphData(flameGraphData, uniqueIdentifier);
  }, [flameGraphData]);

  useEffect(() => {
    if (issueId) {
      fetchFlameGraphData(issueId);
    }
  }, [issueId]);

  async function fetchFlameGraphData(issueId) {
    setLoading(true);
    // 先拿最近一条crash
    let rsp = await RestHelper.mustPost('/api/crash/fetchLastCrashDocInIssue', { appId, issueId });
    const crashMap = rsp.json.data?.crashMap;
    if (!crashMap) {
      setFlameGraphData(null);
      setLoading(false);
      return;
    }

    let jankFlameGraphJson = null;
    if (crashMap.crashExceptionType === ExceptionTypeInt.JankRaw) {
      jankFlameGraphJson = crashMap.jankFlameGraphJson;
    } else { // 这里逻辑跟LastReport的fetchJankRelatedReports类似
      rsp = await RestHelper.mustPost('/api/crash/queryCrashList', {
        appId,
        start: 0,
        rows: 1,
        needEsMapList: true,
        needRetracedStack: true, // 火焰图信息是从堆栈取的
        searchConditionGroup: {
          conditions: [{
            field: FieldName.expUid,
            queryType: QueryType.TERM,
            term: crashMap.expUid,
          }, {
            field: FieldName.exceptionType,
            queryType: QueryType.TERM,
            term: ExceptionTypeName.JankRaw,
          }],
        },
      });
      const relatedJankRawCrashMap = Object.values(rsp.json.ret.crashDatas || {})[0];
      jankFlameGraphJson = relatedJankRawCrashMap?.jankFlameGraphJson;
    }

    if (jankFlameGraphJson) {
      try {
        const jankFlameGraphData = JSON.parse(jankFlameGraphJson);
        setFlameGraphData(jankFlameGraphData);
      } catch (e) {
        message.error(`解析火焰图失败, issueId = ${issueId}`);
      }
    }
    setLoading(false);
  }

  const issueDetailUrlPrefix = getIssueDetailUrlPrefix(ExceptionCategory.JANK);


  const dom = <Spin spinning={loading}><div>
    <div>
      <div>{ isBaseNotCompare ? ze('基准问题', 'Base Issue') : ze('对比问题', 'Compare Issue') }</div>
      { issueId && <div><Link
        to={`/${issueDetailUrlPrefix}/${appId}/${issueId}?pid=${platformId}`}
        target='_blank'
        rel="noopener noreferrer">{ issueId }
      </Link></div> }
      { !issueId && <div>-</div>}
    </div>
    <div style={{ display: 'flex', gap: '12px' }}>
      <div style={{ width: '320px', height: '40vh', overflowY: 'auto', overflowX: 'hidden' }}>
      </div>
      {diffModeTab !== 'difference' && <div style={{ flexGrow: 1 }}>
        { !!flameGraphData && <JankFlameGraph
          data={flameGraphData}
        />}
      </div>}
    </div>
  </div></Spin>;

  return dom;
};

const SubJankIssueFlameGraphModal = ({
  reduxState,
  /** true: 问题详情的任意两个issue对比模式 false: top问题列表的同group对比模式 */
  isIssueDetailCompareMode,
  mergedIssueId,
  mergedIssueList,
  visible,
  onClose,
  onFetchSubJankTopIssues = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const [diffModeTab, setDiffModeTab] = useState('flatten');
  const [flameGraphData, setFlameGraphData] = useState([]);
  const [thresholdValue, setThresholdValue] = useState(5);

  const handleFlameGraphDataChange = (data, type) => {
    const dataToPush = data ?? []; // 使用空值合并运算符简化判断

    setFlameGraphData((prevData) => {
      // 确保prevData至少有2个元素（如果没有则用空数组填充）
      const paddedData = prevData.length >= 2 ? [...prevData] : [...prevData, ...Array(2 - prevData.length).fill([])];

      const newData = [...paddedData]; // 创建副本避免直接修改

      if (type === 'baseFlameGraph') {
        newData[0] = dataToPush; // 替换第一个元素
      } else if (type === 'compareFlameGraph') {
        newData[1] = dataToPush; // 替换第二个元素
      }

      return newData;
    });
  };

  const modalContent = visible && <Spin spinning={loading}><div className={scss.subJankIssueFlameGraph}>
    <div style={{marginLeft:'350px'}}>
      <CsTabs
          bigSize={true}
          defaultActiveKey={diffModeTab}
          onChange={(key)=>{setDiffModeTab(key)}}
          items={[
            {
              label: ze('差分对比','Differential View'),
              key: 'difference',
            },
            {
              label: ze('平铺对比','Parallel View'),
              key: 'flatten',
            },
          ]}
        />
    </div>
    <div style={diffModeTab === 'difference' ? {display: 'flex', gap: '12px'} : {}}>
      { !isIssueDetailCompareMode && <div>
        <SubJankIssueDomItem
          reduxState={reduxState}
          mergedIssueList={mergedIssueList}
          onFetchSubJankTopIssues={onFetchSubJankTopIssues}
          initialMergedIssueId={mergedIssueId}
          diffModeTab={diffModeTab}
          uniqueIdentifier={'baseFlameGraph'}
          onChangeFlameGraphData={handleFlameGraphDataChange}
        />
        <SubJankIssueDomItem
          reduxState={reduxState}
          mergedIssueList={mergedIssueList}
          onFetchSubJankTopIssues={onFetchSubJankTopIssues}
          initialMergedIssueId={mergedIssueId}
          diffModeTab={diffModeTab}
          uniqueIdentifier={'compareFlameGraph'}
          onChangeFlameGraphData={handleFlameGraphDataChange}
        />
      </div> }
      { isIssueDetailCompareMode && <div>
          <IssueDetailCompareModeJankIssueDomItem
            reduxState={reduxState}
            isBaseNotCompare={true}
            diffModeTab={diffModeTab}
            uniqueIdentifier={'baseFlameGraph'}
            onChangeFlameGraphData={handleFlameGraphDataChange}
          />
          <IssueDetailCompareModeJankIssueDomItem
            reduxState={reduxState}
            isBaseNotCompare={false}
            diffModeTab={diffModeTab}
            uniqueIdentifier={'baseFlameGraph'}
            onChangeFlameGraphData={handleFlameGraphDataChange}
          />
        </div>
      }
      {diffModeTab === 'difference' &&  <div style={{flexGrow: 1}}>
        <div>
          <div style={{margin:'15px 0 20px 0'}}>
            <span style={{margin:'0 10px 0 20px'}}>{ze('变化阈值','Variation Threshold')} (%)</span>
            <InputNumber size="small" min={1} max={100} value={thresholdValue} onChange={(value) => {setThresholdValue(value)}} />
          </div>
          <JankDiffFlameGraph
            baseData={flameGraphData[0]}
            currentData={flameGraphData[1]}
            threshold={thresholdValue}
          />
        </div>
      </div>}
    </div>

  </div></Spin>;

  return (
    <Modal
      title="查看火焰图（对比模式）"
      visible={visible}
      onCancel={onClose}
      maskClosable={false}
      footer={null}
      width='calc(100vw - 120px)'
      style={{ top: '24px' }}
      destroyOnClose={true}
    >
      { modalContent }
    </Modal>
  );
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(SubJankIssueFlameGraphModal);
